import React from 'react';
import {getInvalidAreas, SharedAreas} from '@components/call-card/SharedHighlights.utils';
import {Seconds} from '@store/@types/util';
import './SharedHighlightOverlay.sass';

interface DisabledRegionOverlay {
  sharedAreas: SharedAreas;
  duration: Seconds;
  tickHeight: number;
}

/**
 * Render grey bars over the unplayable portions of the call
 */
export const DisabledRegionOverlay: React.FC<DisabledRegionOverlay> = ({
  sharedAreas,
  duration,
  tickHeight,
}) => {
  if (sharedAreas.isEmpty()) return null;

  return (
    <div style={{height: tickHeight}} className="shared-highlight-overlay">
      {getInvalidAreas(sharedAreas, duration).map(([start, end]) => {
        const startPct = start / duration;
        const endPct = end / duration;
        const width = endPct - startPct;
        return (
          <div
            key={`${start}-${end}`}
            style={{
              left: startPct * 100 + '%',
              width: width * 100 + '%',
            }}
            className="invalid-area"
          />
        );
      })}
    </div>
  );
};
